import { __rest } from "tslib";
import * as React from 'react';
import styles from '@patternfly/react-styles/css/components/List/list';
import { css } from '@patternfly/react-styles';
export var OrderType;

(function (OrderType) {
  OrderType["number"] = "1";
  OrderType["lowercaseLetter"] = "a";
  OrderType["uppercaseLetter"] = "A";
  OrderType["lowercaseRomanNumber"] = "i";
  OrderType["uppercaseRomanNumber"] = "I";
})(OrderType || (OrderType = {}));

export var ListVariant;

(function (ListVariant) {
  ListVariant["inline"] = "inline";
})(ListVariant || (ListVariant = {}));

export var ListComponent;

(function (ListComponent) {
  ListComponent["ol"] = "ol";
  ListComponent["ul"] = "ul";
})(ListComponent || (ListComponent = {}));

export var List = function List(_a) {
  var _a$className = _a.className,
      className = _a$className === void 0 ? '' : _a$className,
      _a$children = _a.children,
      children = _a$children === void 0 ? null : _a$children,
      _a$variant = _a.variant,
      variant = _a$variant === void 0 ? null : _a$variant,
      _a$isBordered = _a.isBordered,
      isBordered = _a$isBordered === void 0 ? false : _a$isBordered,
      _a$isPlain = _a.isPlain,
      isPlain = _a$isPlain === void 0 ? false : _a$isPlain,
      _a$iconSize = _a.iconSize,
      iconSize = _a$iconSize === void 0 ? 'default' : _a$iconSize,
      _a$type = _a.type,
      type = _a$type === void 0 ? OrderType.number : _a$type,
      _a$ref = _a.ref,
      ref = _a$ref === void 0 ? null : _a$ref,
      _a$component = _a.component,
      component = _a$component === void 0 ? ListComponent.ul : _a$component,
      props = __rest(_a, ["className", "children", "variant", "isBordered", "isPlain", "iconSize", "type", "ref", "component"]);

  return component === ListComponent.ol ? React.createElement("ol", Object.assign({
    ref: ref,
    type: type
  }, props, {
    className: css(styles.list, variant && styles.modifiers[variant], isBordered && styles.modifiers.bordered, isPlain && styles.modifiers.plain, iconSize && iconSize === 'large' && styles.modifiers.iconLg, className)
  }), children) : React.createElement("ul", Object.assign({
    ref: ref
  }, props, {
    className: css(styles.list, variant && styles.modifiers[variant], isBordered && styles.modifiers.bordered, isPlain && styles.modifiers.plain, iconSize && iconSize === 'large' && styles.modifiers.iconLg, className)
  }), children);
};
List.displayName = 'List';